// ============================================================
// VCS.CallHistory — Anrufliste (Call History)
// ============================================================
window.VCS = window.VCS || {};

VCS.CallHistory = class {

    // ── Konstruktor ──────────────────────────────────────────

    constructor() {
        this._view = {
            list: $('#callHistoryList'),
        };
    }

    // ── Öffentliche Methoden ─────────────────────────────────

    async loadHistory() {
        if (!VCS.state.chatMyPhone || !VCS.state.chatAuthToken) {
            return;
        }
        const list = this._view.list[0];
        if (!list) {
            return;
        }

        try {
            const res = await fetch(VCS.Chat.API_BASE + '/call/history?limit=50&offset=0', {
                headers: VCS.chat?.authHeaders()
            });
            if (!res.ok) {
                return;
            }
            const data = await res.json();
            const calls = data.calls || [];

            if (calls.length === 0) {
                list.innerHTML = `<div class="chat-list-empty"><span>${t('callHistoryEmpty')}</span></div>`;
                return;
            }

            list.innerHTML = calls.map(call => this._renderCallItem(call)).join('');

            list.querySelectorAll('.call-history-item').forEach(item => {
                item.addEventListener('click', async () => {
                    const phone = item.dataset.phone;
                    const name = item.dataset.name;
                    const callType = item.dataset.lastCallType || 'video';
                    if (!phone || !name) return;

                    const isVideo = callType === 'video';
                    const msgKey = isVideo ? 'confirmStartVideoCall' : 'confirmStartAudioCall';
                    const iconSvg = isVideo
                        ? '<svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>'
                        : '<svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>';

                    const ok = await VCS.ui?.showConfirm?.(t(msgKey).replace('{0}', name), iconSvg);
                    if (ok) {
                        void VCS.chatContacts?.callContact?.(phone, name, callType);
                    }
                });
            });
        } catch (e) {
            console.error('[call-history] load error:', e);
        }
    }

    // ── Private ──────────────────────────────────────────────

    _renderCallItem(call) {
        const myPhone = VCS.state.chatMyPhone;
        const isOutgoing = call.callerPhone === myPhone;
        const peerPhone = isOutgoing ? call.calleePhone : call.callerPhone;
        const peerChat = VCS.state.chatChats?.find(c => VCS.chat?.peerPhone?.(c) === peerPhone);
        const peerUser = VCS.state.usersRegistry?.[peerPhone] || peerChat;
        // Dating-Match: kein Nummern-Fallback -- die Nummer bleibt in der UI unsichtbar.
        const nameFallback = peerChat?.isDatingMatch ? t('datingContactMatch') : peerPhone;
        const rawName = peerUser?._peerName || peerUser?.displayName || nameFallback;
        const peerName = escapeHtml(rawName);
        const initial = (rawName || '?').charAt(0).toUpperCase();

        const isVideo = call.callType === 'video';
        const typeIcon = isVideo ? this._videoIcon() : this._phoneIcon();

        const directionIcon = isOutgoing ? this._outgoingArrow() : this._incomingArrow();
        const isMissed = call.status === 'missed' || call.status === 'declined';
        const statusClass = isMissed ? 'call-history-missed' : '';

        const time = call.startedAt ? this._formatDateTime(call.startedAt) : '';
        const duration = call.duration > 0 ? this._formatDuration(call.duration) : '';

        return `<div class="call-history-item chat-list-item cursor-pointer ${statusClass}"
                     data-phone="${escapeHtml(peerPhone)}"
                     data-name="${peerName}"
                     data-last-call-type="${escapeHtml(call.callType || 'video')}">
            <div class="chat-list-avatar">${initial}</div>
            <div class="chat-list-body">
                <div class="chat-list-top-row">
                    <span class="chat-list-name">${peerName}</span>
                    <span class="chat-list-time">${time}</span>
                </div>
                <span class="chat-list-preview call-history-detail">
                    ${directionIcon} ${typeIcon}
                    ${duration ? `<span class="call-history-duration">${duration}</span>` : ''}
                </span>
            </div>
        </div>`;
    }

    _formatDateTime(ts) {
        const d = new Date(ts);
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const day = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        const time = d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0');

        if (day.getTime() === today.getTime()) {
            return time;
        }
        if (day.getTime() === today.getTime() - 86400000) {
            return (t('chatYesterday') || 'Gestern') + ' ' + time;
        }
        return d.getDate().toString().padStart(2, '0') + '.'
            + (d.getMonth() + 1).toString().padStart(2, '0') + '. '
            + time;
    }

    _formatDuration(ms) {
        const sec = Math.round(ms / 1000);
        const m = Math.floor(sec / 60);
        const s = sec % 60;
        if (m > 0) {
            return m + ':' + s.toString().padStart(2, '0') + ' min';
        }
        return s + 's';
    }

    _phoneIcon() {
        return `<svg class="call-history-type-icon" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>`;
    }

    _videoIcon() {
        return `<svg class="call-history-type-icon" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="7" width="13" height="10" rx="2"></rect>
            <path d="M15 10l5-3v10l-5-3z"></path>
        </svg>`;
    }

    _outgoingArrow() {
        return `<svg class="call-history-direction-icon" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7 17L17 7"/><path d="M7 7h10v10"/>
        </svg>`;
    }

    _incomingArrow() {
        return `<svg class="call-history-direction-icon" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 7L7 17"/><path d="M17 17H7V7"/>
        </svg>`;
    }

    // ── Init ─────────────────────────────────────────────────

    init() {
        // Keine zusätzliche Initialisierung nötig
    }
};
